import { CommunicationCategory } from '@bariendo/lib/constants';
import { MedplumClient } from '@medplum/core';
import { Reference, Task } from '@medplum/fhirtypes';
import { ReactNode } from 'react';
import { CommunicationFragment } from './graphql';

export interface NotificationItem {
  id: string;
  content: string;
  timestamp: Date;
  isArchived: boolean;
  isRead: boolean;
  task: Task;
  sourceCommunication: CommunicationFragment | undefined;
  priorityStatus?: 'normal' | 'urgent' | 'overdue';
  name: string;
}

export const TypeFilter = {
  ALL: 'all',
  TASKS: 'tasks',
  SMS: CommunicationCategory.SMS_MESSAGE,
  CALL: CommunicationCategory.PHONE_CALL,
  CHAT: CommunicationCategory.CHAT,
  NOTE: CommunicationCategory.STANDALONE_NOTE,
  FAX: CommunicationCategory.INBOUND,
} as const;

export type TypeFilter = (typeof TypeFilter)[keyof typeof TypeFilter];
export const RowActionKind = {
  ARCHIVE: 'archive',
  UNARCHIVE: 'unarchive',
} as const;

export type RowActionKind = (typeof RowActionKind)[keyof typeof RowActionKind];

export interface ToolbarActionContext {
  medplum: MedplumClient;
  selectedCount: number;
  selectedNotifications: NotificationItem[];
  selectedRefs: Reference<Task>[];
}

export interface ToolbarAction {
  id: string;
  label: string;
  icon: ReactNode;
  color: string;
  variant?: string;
  handler: (medplum: MedplumClient, selectedRefs: Reference<Task>[], onComplete: () => void) => Promise<void>;
  isVisible?: (ctx: ToolbarActionContext) => boolean;
  isDisabled?: (ctx: ToolbarActionContext) => boolean;
}
